import React from 'react';
import JobPreparation from '@components/preparation/JobPreparation';
import InterviewPractice from '@components/preparation/InterviewPractice';
import AccaTest from '@components/preparation/AccaTest';
import PaccTest from '@components/preparation/PaccTest';
import ContentsList from '@components/preparation/contentsList';
import JobPreparationMbti from './JobPreparationMbti';
import classnames from 'classnames/bind';
import styles from './preparation.module.scss';
const cx = classnames.bind(styles);

const Preparation = () => {
  return (
    <div className={cx('preparationArea')}>
      <div className={cx('preparationInner')}>
        <strong className={cx('sectionTitle')}>취업준비는, 이제 잡다에서 끝내세요.</strong>

        {/* 취업준비 영역 */}
        <JobPreparation />

        {/* 면접연습 영역 */}
        <InterviewPractice />

        {/* 취준 MBTI 영역 */}
        <JobPreparationMbti />

        {/* 역검(역량검사) 영역 */}
        <AccaTest />

        {/* 개발자 검사 영역 */}
        <PaccTest />
      </div>

      {/* 취업콘텐츠 영역 */}
      <ContentsList />
    </div>
  );
};

export default Preparation;
